import styled from "styled-components";
import { Form, Typography, DatePicker, Button } from "antd";

export const StyledComponentWrapper = styled.div`
  background-color: #ffffff;
  width: 100%;
  max-width: 1480px;
  padding: 40px 40px;
  @media (max-width: 1800px) {
    max-width: 1300px;
  }

  @media (max-width: 1550px) {
    max-width: 1080px;
  }
  @media (max-width: 1300px) {
    max-width: 950px;
  }

  @media (max-width: 1199px) {
    max-width: 780px;
  }
  @media (max-width: 788px), (max-width: 922px) {
    max-width: 712px;
  }
  @media (max-width: 720px) {
    max-width: 372px;
  }
`;

export const StyledFlexBreaker = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 500px) {
    flex-direction: column;
  }
`;

export const StyledFormItem = styled(Form.Item)`
  width: 47%;
  @media (max-width: 500px) {
    width: 100%;
  }
`;

export const StyledFormItemName = styled(Form.Item)`
  width: 40%;
  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const StyledRegisterButton = styled(Button)`
  margin-left: 32%;
  margin-right: 32%;
  width: 36%;
  @media (max-width: 500px) {
    margin: 0;
    width: 100%;
  }
`;

export const StyledDatePicker = styled(DatePicker)`
  background: white;
  width: 100%;
  > .ant-picker-input .ant-picker-clear:hover {
    color: unset !important;
  }
`;

export const Title = styled(Typography.Title)`
  && {
    font-size: 36px;
    font-weight: 700;
  }
`;